import ReactDOM from "react-dom";
import { HEADER_BUTTON_AREA_DOM_ID } from "./HeaderButtonArea";
import { SaveFormButton } from "../form/SaveFormButton";

export const HeaderSaveFormButton: React.FC = () => {
  const domElement = document.getElementById(HEADER_BUTTON_AREA_DOM_ID);

  if (!domElement) {
    return null;
  }

  return ReactDOM.createPortal(<SaveFormButton />, domElement);
};
